import React, { Component } from "react";
import ReCaptcha from "react-google-recaptcha";
import { getLangData } from '../services/lang';

class Contact extends Component<{}, ContactState> {

    contact2MailUrl = 'https://europe-west1-sklein-website.cloudfunctions.net/contact ';

    constructor(props: Readonly<{}>) {
        super(props);

        this.state = {
            name: '',
            email: '',
            subject: '',
            message: '',

            recaptchaToken: null,

            isSending: false,
            sendingFinished: false,
            sendingSuceed: false,
            errorMsg: '',
        };

        this.send = this.send.bind(this);
    }

    send() {
        const {
            recaptchaToken
        } = this.state;
        const langData = getLangData();


        const {
            name,
            email,
            subject,
            message
        } = this.state;

        let errorMsg = '';
        if (name === '') {
            errorMsg = langData.contact.missingName;
        } else if (email === '') {
            errorMsg = langData.contact.missingEmail;
        } else if (subject === '') {
            errorMsg = langData.contact.missingSubject;
        } else if (message === '') {
            errorMsg = langData.contact.missingMessage;
        } else if (recaptchaToken == null) {
            errorMsg = langData.contact.missingRecaptcha;
        }
        if (errorMsg !== '') {
            this.setState({
                sendingFinished: true,
                sendingSuceed: false,
                isSending: false,
                errorMsg: errorMsg
            });
            return;
        }

        const body = {
            recaptchaToken: recaptchaToken,
            name: name,
            email: email,
            subject: subject,
            message: message
        };

        fetch(this.contact2MailUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // 'Access-Control-Allow-Origin': 
            },
            body: JSON.stringify(body)
        }).then(res => this.setState({
            sendingFinished: true,
            sendingSuceed: res.ok,
            isSending: false,
            errorMsg: langData.contact.failed
        })).catch(() => this.setState({
            sendingFinished: true,
            sendingSuceed: false,
            isSending: false,
            errorMsg: langData.contact.failed
        }));
    }

    render() {

        const langData = getLangData();

        const {
            sendingFinished,
            sendingSuceed,
            errorMsg
        } = this.state;

        let alert = <div />;
        if (sendingFinished) {
            if (sendingSuceed) {
                alert = <div className="alert alert-success mb-0" role="alert">
                    {langData.contact.success}
                </div>;
            } else {
                alert = <div className="alert alert-danger mb-0" role="alert">
                    {errorMsg}
                </div>;
            }
        }

        return (
            <div className="container" >

                <div className="row mb-3">
                    <div className="col">
                        <p className="h1 fw-300">{langData.contact.header2}</p>
                    </div>
                </div>

                <div className="row d-flex justify-content-center">
                    <div className="col-6">
                        <p className="lead">{langData.contact.fillOut}</p>
                    </div>
                </div>

                <div className="row d-flex justify-content-center">
                    <div className="col-6">
                        <hr />
                        <div className="form">
                            <div className="form-group">
                                <label htmlFor="nameInput">{langData.contact.name}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="nameInput"
                                    name="name"
                                    placeholder={langData.contact.enterName}
                                    onChange={(evt) => this.setState({ name: evt.currentTarget.value })}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="emailInput">{langData.contact.email}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="emailInput"
                                    name="email"
                                    placeholder={langData.contact.enterEmail}
                                    onChange={(evt) => this.setState({ email: evt.currentTarget.value })}
                                />
                                <small id="emailDisclaimer" className="form-text text-muted">
                                    {langData.contact.emailHint}
                                </small>
                            </div>
                            <hr />
                            <div className="form-group">
                                <label htmlFor="subjectInput">{langData.contact.subject}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="subjectInput"
                                    name="subject"
                                    placeholder={langData.contact.enterSubject}
                                    onChange={(evt) => this.setState({ subject: evt.currentTarget.value })}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="messageInput">{langData.contact.message}</label>
                                <textarea
                                    className="form-control"
                                    id="messageInput"
                                    name="message"
                                    placeholder={langData.contact.enterMessage}
                                    rows={10}
                                    onChange={(evt) => this.setState({ message: evt.currentTarget.value })}
                                />
                            </div>
                            <hr />
                        </div>
                    </div>
                </div>

                <div className="row d-flex justify-content-center mb-3">
                    <div className="col-6 d-flex justify-content-center">
                        <ReCaptcha
                            sitekey="6LdKZwEVAAAAAKmB6wUg_nhYZ4sFq3N0kOVrEE5S"
                            onChange={(val) => this.setState({ recaptchaToken: val })}
                        />
                    </div>
                </div>
                <hr />

                <div className="row d-flex justify-content-center mb-3">
                    <div className="col-6">
                        {alert}
                    </div>
                    <div className="col-3 d-flex justify-content-end">
                        <button
                            type="button"
                            className="btn btn-outline-dark btn-block"
                            onClick={() => this.setState({ isSending: true }, this.send)}
                        >{this.state.isSending ?
                            <div className="spinner-border mr-3" role="status" /> :
                            langData.contact.send}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

type ContactState = {
    name: string;
    email: string;
    subject: string;
    message: string;

    recaptchaToken: string | null;

    isSending: boolean;
    sendingFinished: boolean;
    sendingSuceed: boolean;
    errorMsg: string;
};

export default Contact;